import React, { useState } from 'react';

const TrustBar = () => {
  const [isPaused, setIsPaused] = useState(false);
  const publicUrl = process.env.PUBLIC_URL || '';
  const carriers = [
    { name: 'Blue Dart', logo: `${publicUrl}/logos/bluedart.webp` },
    { name: 'Delhivery', logo: `${publicUrl}/logos/delhivery.webp` },
    { name: 'XpressBees', logo: `${publicUrl}/logos/xpressbees.webp` },
    { name: 'Shadowfax', logo: `${publicUrl}/logos/shadowfax.webp` },
    { name: 'Blitz', logo: `${publicUrl}/logos/blitz.webp` },
    { name: 'DHL', logo: `${publicUrl}/logos/dhl.webp` },
    { name: 'Ekart', logo: `${publicUrl}/logos/ekart.webp` },
    { name: 'Pickndel', logo: `${publicUrl}/logos/pickndel.webp` },
    { name: 'DTDC', logo: `${publicUrl}/logos/dtdc.webp` }
  ];
  const marqueeCarriers = [...carriers, ...carriers];

  return (
    <section className="relative pt-16 pb-4 bg-gradient-to-br from-blue-50 to-white overflow-hidden">
      {/* Decorative line pattern */}
      <div className="absolute inset-0" style={{
        backgroundImage: 'linear-gradient(rgba(59, 130, 246, 0.02) 2px, transparent 2px)',
        backgroundSize: '40px 40px'
      }}></div>
      
      {/* Floating orb */}
      <div className="absolute top-0 right-20 w-40 h-40 bg-gradient-to-br from-blue-200/20 to-blue-300/10 rounded-full blur-2xl"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header - Compact */}
        <div className="text-center mb-10">
          <span className="text-blue-800 font-semibold text-sm uppercase tracking-wide">Carrier Support</span>
          <h2 className="text-3xl md:text-4xl font-bold mt-2 mb-2 text-gray-900">
            Integrated Carriers <span className="text-blue-800">& More</span>
          </h2>
          <p className="text-gray-600">Partner with India's leading logistics providers</p>
        </div>

        <div
          className="relative overflow-hidden"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          onTouchStart={() => setIsPaused(true)}
          onTouchEnd={() => setIsPaused(false)}
        >
          <div className={`flex w-max animate-logo-scroll items-center gap-1.5 md:gap-2 ${isPaused ? 'pause-logo-loop' : ''}`}>
            {marqueeCarriers.map((carrier, index) => (
              <div
                key={`${carrier.name}-${index}`}
                className="flex h-[180px] w-[300px] shrink-0 items-center justify-center"
              >
                <img
                  src={carrier.logo}
                  alt={carrier.name}
                  className="max-h-full max-w-full object-contain"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            ))}
          </div>

          <div className="pointer-events-none absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-blue-50 to-transparent"></div>
          <div className="pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-white to-transparent"></div>
        </div>
      </div>

      <style jsx>{`
        @keyframes logo-scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-logo-scroll {
          animation: logo-scroll 35s linear infinite;
        }

        .pause-logo-loop {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default TrustBar;
